<template>
  <div>
    <v-container>
      <!-- Partie génerique -->
      <AlertMessage
        v-if="notAllowedTerminologies && notAllowedTerminologies.length > 0 && protectedTerminologies && protectedTerminologies.length != 0"
        type="info" class="mb-3">
        <p v-if="fromDereferencePage" style="white-space: pre-line;">L'accès aux concepts dans certaines terminologies
          nécessite de <a :href="authenticationUrl">Se&nbsp;Connecter</a>.</p>
        <p v-if="!fromDereferencePage" style="white-space: pre-line;">La recherche de concepts dans certaines
          terminologies nécessite de <a :href="authenticationUrl">Se&nbsp;Connecter</a>.</p>
        <div v-if="messageNotAccessibleTerminoInURL && messageNotAccessibleTerminoInURL.length > 0">
          {{ messageNotAccessibleTerminoInURL }}
        </div>

        <template v-slot:collapseable_content>
          <p style="white-space: pre-line;">{{ message }}</p>
          <div class="wysiwyg">
            <ul>
              <li v-for="(terminology, index) in protectedTerminologies" :key="index">{{ terminology.title }}</li>
            </ul>
          </div>
        </template>
      </AlertMessage>

      <!-- Partie terminologies SNOMED -->
      <AlertMessage v-if="snomedTerminologies && snomedTerminologies.length > 0" type="info">
        <p style="white-space: pre-line;">{{ messageSnomed }} <a
            v-bind:href="$searchResultManager.wordPressBaseUrl + '/licences-snomed/'"> affiliant auprès du NRC SNOMED CT
          </a><span> , ou en </span> <a @click="showPopinBrowserLicence" class="lien"> acceptant temporairement la
            licence “Navigateur SNOMED CT”</a>
        </p>

        <template v-slot:collapseable_content>
          <p style="white-space: pre-line;">{{ message }}</p>
          <div>
            <div class="wysiwyg">
              <ul>
                <li v-for="(terminology, index) in snomedTerminologies" :key="index">{{ terminology.title }}</li>
              </ul>
            </div>
          </div>
        </template>
      </AlertMessage>

    </v-container>
    <SnomedBrowserLicence :show="show" :popinSnomedBrowserLicence="popinSnomedBrowserLicence"
      @closeModal="show = false">
    </SnomedBrowserLicence>
  </div>
</template>

<script>
import Store from '../concepts-store';
import AlertMessage from './AlertMessage';
import Snomed from '../snomed';
import SnomedBrowserLicence from "./snomed/SnomedBrowserLicence";

export default {
  name: "AlertProtectedTerminologies",

  components: {
    AlertMessage,
    SnomedBrowserLicence
  },
  props: {
    notAllowedTerminologies: Array,
    fromDereferencePage: Boolean
  },

  data() {
    return {
      store: Store.state,
      message: "",
      messageSnomed: "La recherche de concepts dans les éditions SNOMED CT ci-dessous nécessite d'accepter les licences associées en vous ",
      protectedTerminologiesExpanded: false,
      snomedTerminologies: undefined,
      protectedTerminologies: undefined,
      snomedTerminologiesExpanded: false,
      show: false,
      consultEntireMessage: false,
      popinSnomedBrowserLicence: true,
      messageNotAccessibleTerminoInURL: undefined,
      authenticationUrl: this.$searchResultManager.authenticationUrl,
      localNotAllowedTerminologies: []
    }
  },


  async created() {
    // Initialize local copy of the prop to avoid mutating it directly
    this.localNotAllowedTerminologies = this.notAllowedTerminologies ? [...this.notAllowedTerminologies] : [];
    this.processProtectedAndSnomedTerminologies();
    this.$root.$on('updateAlertMessage', data => {
      this.updateAlertMessageIfSelectedTerminologiesAreProtected(data);
    });
    if (this.fromDereferencePage) {
      // Changement mineure de texte dans le cas où le bandeau d'avertissement concerne la page de déreférencement
      this.message = "L'accès aux concepts dans certaines terminologies nécessite d'être connecté.";
      this.messageSnomed = "L'accès aux concepts des éditions SNOMED CT ci-dessous nécessite d'accepter les licences associées en vous ";
    }
  },
  methods: {
    /**
     *  Determine les terminologies protegées et Snomed
     */
    async processProtectedAndSnomedTerminologies() {
      this.protectedTerminologies = await this.localNotAllowedTerminologies.filter(terminology => { return !terminology.snomedCT });
      // Si l'utilisateur a accepté la licence navigateur dans les 24 dernières heure, il peut consulter les concepts SNOMED
      if (!Snomed.checkIfSnomedBrowerLicenceValid()) {
        this.snomedTerminologies = await this.localNotAllowedTerminologies.filter(terminology => { return terminology.snomedCT });
      } else {
        // Cas où la licence navigateur a été acceptée - Retirer les licences SNOMED  de la liste
        this.localNotAllowedTerminologies = await this.localNotAllowedTerminologies.filter(terminology => { return !terminology.snomedCT });
      }
    },
    /**
     *  Affiche la popin d'acceptation de la licence navigateur SNOMED
     */
    showPopinBrowserLicence() {
      this.show = true;
    },
    /**
     * recharge la page après l'acceptation de la licence navigateur
     */
    async forceRerender() {
      location.reload();
    },

    /**
     * Masquer les listes de terminologies dépliées
     */
    async hideDetails() {
      this.consultEntireMessage = false;
    },
    updateAlertMessageIfSelectedTerminologiesAreProtected(terminologiesList) {
      if (Store.checkUrlParameterExists('terminologies')) {
        let terminolgiesNotAllowed = Store.getCommonNotAccessibleTerminologiesBetweenUrlParametersTerminologiesAndTerminologiesList(this.$route.query.terminologies, terminologiesList, "title");
        if (terminolgiesNotAllowed.length > 0) {
          this.messageNotAccessibleTerminoInURL =
            "Une ou plusieurs terminologies sélectionnées ne sont pas accessibles.\r\n" +
            "La recherche lancée n’a pas inclus la ou les terminologies protégées suivantes : " + terminolgiesNotAllowed.join(', ')
            ;
        }
      }
    }
  }
}
</script>

<style scoped>
.lien {
  text-decoration: underline !important;
  color: #1D71B8 !important;
}
</style>